<!--
  ~ Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<auth-shared-auth-logs [authLogs]='authLogs()'
                       [totalRecords]='totalRecords()'
                       [sortField]="'loginDateAndTime'"
                       (lazyLoad)='loadAuthLogsLazy($event)'>
</auth-shared-auth-logs>
